import styled from 'styled-components'
import { height, HeightProps, width, WidthProps } from 'styled-system'

export const Container = styled.div<WidthProps & HeightProps>`
  position: relative;
  display: flex;
  width: 100%;

  ${width}
  ${height}
`

export const BackgroundImageHolder = styled.div<WidthProps & HeightProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ${width}
  ${height}
`
